module.exports = __webpack_public_path__ + "assets/phone.a4644ff3.svg";